const bound = new WeakSet();

/**
 * Wires "Search Jobs" triggers to scroll to the hero search and focus its input.
 *
 * @param {Object} [options]
 * @param {string} [options.button_selector] Selector for the trigger elements.
 * @param {string} [options.input_selector]  Selector for the search input.
 * @param {string} [options.hero_selector]   Selector for the hero section.
 */
export function init_search_jobs(options = {}) {
	const {
		button_selector = `[data-hub-search]`,
		input_selector = `.hub-hero #query`,
		hero_selector = `#hero`,
	} = options;

	const button_els = document.querySelectorAll(button_selector);

	if (!button_els.length) {
		return;
	}

	function focus_query(attempts) {
		const input_el = document.querySelector(input_selector);

		if (input_el) {
			input_el.focus({
				preventScroll: true,
			});

			return;
		}

		if (attempts < 20) {
			window.setTimeout(() => focus_query(attempts + 1), 100);
		}
	}

	button_els.forEach((button_el) => {
		if (bound.has(button_el)) {
			return;
		}

		bound.add(button_el);

		button_el.addEventListener(`click`, (event) => {
			event.preventDefault();

			const hero_el = document.querySelector(hero_selector);

			if (hero_el) {
				hero_el.scrollIntoView({
					behavior: `smooth`,
					block: `start`,
				});
			}

			focus_query(0);
		});
	});
}
